<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  eventComputed,
  eventListMethod,
  authComputed,
  collegeComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Event List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      eventlist: {},
      allEventList: {},
      collegelist: [],
      collegeId: 'All',
      platformId: 'All',
      isUserAdmin: false,
      siteconfiglist: [],
      allCollegeList: [],
      fields: [
        { value: 'name', text: 'Name', sortable: true, colType: 'default' },
        { value: 'date', text: 'Event Date', sortable: true, colType: 'date' },
        {
          value: 'eventtime',
          text: 'Time',
          sortable: false,
          colType: 'default',
        },
        {
          value: 'eventstatus',
          text: 'Event Approved',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'categoryName',
          text: 'Category',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'name', label: 'Name', colType: 'default' },
        { key: 'features', label: 'Features', colType: 'list' },
        { key: 'topics', label: 'Topics', colType: 'list' },
        { key: 'description', label: 'Description', colType: 'html' },
        { key: 'overview', label: 'Overview', colType: 'html' },
        { key: 'type', label: 'Type', colType: 'default' },
        { key: 'date', label: 'Date', colType: 'date' },
        { key: 'time', label: 'Time', colType: 'eventtime' },
        { key: 'createdAt', label: 'Published On ', colType: 'date' },
      ],
    }
  },
  computed: {
    ...eventComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getListOfEvents()
    this.getColleges()
  },
  methods: {
    ...eventListMethod,
    ...collegeListMethod,
    ...siteListMethod,
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    getEvents() {
      if (this.collegeId !== 'All') {
        let listitems = []
        this.allEventList.docs.forEach((element) => {
          if (element.college_id === this.collegeId) {
            listitems.push(element)
          }
        })
        this.eventlist.docs = listitems
      } else {
        if (this.role !== 'admin') {
          this.eventlist.docs = this.allEventList.docs
        } else {
          let listitems = []
          this.allEventList.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              listitems.push(element)
            }
          })
          this.eventlist.docs = listitems
        }
      }
    },

    getPlatformColleges() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allEventList.docs.forEach((element) => {
          if (element.platform_id.includes(Number(this.platformId))) {
            listitems.push(element)
          }
        })
        this.eventlist.docs = listitems
      } else {
        this.eventlist.docs = this.allEventList.docs
      }
    },

    // Get list of all events role wise
    getListOfEvents() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchEventList({ filter })
        .then((eventList) => {
          this.eventlist = JSON.parse(JSON.stringify(eventList))
          this.allEventList = JSON.parse(JSON.stringify(eventList))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link
              v-if="
                isAdmin() ||
                isCollege() ||
                isHOD() ||
                isTeacher() ||
                isAdministrator()
              "
              tag="button"
              to="/event-add"
              class="btn btn-info mb-2"
            >
              <i class="ti-plus"></i><span> Add Event</span> </router-link
            >&nbsp;
            <router-link
              v-if="role === ADMIN_ROLE"
              tag="button"
              to="/event-requests"
              class="btn btn-info mb-2"
            >
              <i class="ti-pin"></i><span> Approve Event</span> </router-link
            ><br />
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformColleges"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              v-if="
                (role === 'admin' && isUserAdmin) || role === 'administrator'
              "
              label="Select College"
              label-for="input-1"
            >
              <b-form-select
                v-model="collegeId"
                :options="collegelist"
                style="width: 50%"
                @change="getEvents"
              ></b-form-select>
            </b-form-group>
            <Table
              :fields="fields"
              :items="eventlist ? eventlist.docs : []"
              :editbtn="true"
              :viewbtn="true"
              :deletebtn="true"
              :event="true"
              :display-fields="displayFields"
            >
            </Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
